import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <TopicsSection />
        <FaqSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}